export default {
  PAGE_TITLE: "問卷調查完成",
  ANSWER_CONTENT: "回答內容",
  THANK_YOU_ANSWER: "感謝您參與調查。",
};
